module.exports = __webpack_public_path__ + "img/quanpinlei.32c216cf.png";